import React from "react";
import { Check } from "lucide-react";

import { Chip } from "@/shared/components/ui-kit";
import { InterfaceIcon } from "./InterfaceIcon";

import type { InterfaceDef } from "@/shared/types";

/* One channel of the catalog. Connecting always starts a new interface — an
   agent may have several bots of one type — so a tick marks "you have one",
   never "done". A channel without a setup flow yet says so and does nothing. */
export function CatalogCard({ meta, connected, comingSoon, onClick }: {
  meta: InterfaceDef;
  connected: boolean;
  comingSoon: boolean;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      disabled={comingSoon}
      className="card-hover press text-left rounded-[14px] bg-[var(--surface)] ring-1 ring-[var(--hairline)] shadow-lift p-3.5 flex items-start gap-3 min-w-0 disabled:opacity-50 disabled:pointer-events-none"
    >
      <InterfaceIcon meta={meta} size={34} iconSize={17} rounded={9} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <span className="text-[13.5px] font-medium text-[var(--text-primary)] tracking-[-0.005em] truncate">
            {meta.name}
          </span>
          {connected && <Check className="w-3 h-3 shrink-0 text-[var(--success)]" strokeWidth={2} />}
          {comingSoon && <Chip>Coming soon</Chip>}
        </div>
        <p className="m-0 mt-[2px] text-[12px] leading-[1.5] text-[var(--text-tertiary)] line-clamp-2">{meta.desc}</p>
      </div>
    </button>
  );
}
